import * as React from "react";
import { useFormikContext } from "formik";
import QueryValidationDisplay from "./QueryValidationDisplay";
export { DocumentationIcon, Explanation } from "./QueryValidationDisplay";
const QueryValidation = ({ validationExplanations = [] }) => {
  const {
    errors: { queryString: queryStringErrors }
  } = useFormikContext();
  return /* @__PURE__ */ React.createElement(
    QueryValidationDisplay,
    {
      queryStringErrors,
      validationExplanations
    }
  );
};
export default QueryValidation;
